import Image from 'next/image';
import styles from './TreatmentCaseStudy.module.css';
import { useGlobalContext } from '@/libs/context/GlobalContext';
import { ICaseStudyDetails } from '@/interfaces';
type props = {
    caseStudyData: ICaseStudyDetails
}
export function TreatmentCaseStudy({ caseStudyData }: props) {
    const { props: { isMobileView } } = useGlobalContext()
    return (
        <section className={styles.treatmentCase}>
            <div className="container">
                <div className={`${styles.treatmentCaseBox} ${styles.ga65}`}>
                    <figure className={styles.imageBox}>
                        {isMobileView ? <Image src={caseStudyData.hero_image_mobile || "/assets/images/case-Study.png"} height={254} width={345} alt="" className="imgResponsive" />
                            : <Image src={caseStudyData.hero_image_desktop || "/assets/images/case-Study.png"} height={425} width={620} alt="" className="imgResponsive" />
                        }
                    </figure>
                    <div className="treatmentCasetextBox gap text-sd-center">
                        <p className="font20 fontsm14 fontMedium">{caseStudyData.sub_title}</p>
                        <h2 className="sectionHeading leftHeading">{caseStudyData.title}</h2>
                        <p className="font16 fontRegular text666 lineHeight23">{caseStudyData.description}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}